import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
    // CDR Viewer
    cdrViewerRequestData: {
        date_from: moment().startOf("day").format("DD/MM/YYYY"),
        date_to: moment().endOf("day").format("DD/MM/YYYY"),
        needsFetch: false,
        page: 1,
        srcdst: "",
        callType: [],
        did: [],
        queue: [],
        tags: [],
        client: "",
        firstLoad: true,
        debugMode: false,
        totalItems: 0,
        totalPages: 0,
    },
    cdrViewerResponseData: {
        data: [],
        devices: [],
        dids: [],
        queues: [],
        ivrs: [],
        lastUpdate: "",
        totalPages: 0,
        stats: {
            totalInboundCalls: 0,
            totalOutboundCalls: 0,
            meanDidWaitingTime: {}, // Per DID
            maxSimultaneousCalls: {}, // Per DID
            maxSimultaneousCallsTime: "",
            noAnswer: 0,
            noAnswerArr: [], // Will contain objects with keys (src, dst, date, clientName, clientVAT, queueHistory)
        },
        totals: {
            billsec: 0,
            waiting: 0,
            duration: 0,
        },
        totalsPerInner: {},
    },

    // Dial
    hasDialAbility: false,
    showDial: false,
    dialNumber: "",

    cdrAiTagRequestData: {
        name: "",
        forCompany: "",
    },

    cdrAiTagResponseData: [],
}

export const CRMSlice = createSlice({
    name: "crm-slice",
    initialState,
    reducers: {
        setCDRViewerRequestData: (state, {payload}) => {
            state.cdrViewerRequestData = payload;
        },
        setCDRViewerResponseData: (state, {payload}) => {
            state.cdrViewerResponseData = payload;
        },
        setHasDialAbility: (state, {payload}) => {
            state.hasDialAbility = payload;
        },
        setShowDial: (state, {payload}) => {
            state.showDial = payload;
        },
        setDialNumber: (state, {payload}) => {
            state.dialNumber = String(payload).trim().replace(/^(\+30)/, "");
        },
        setCDRAiTagRequestData: (state, {payload}) => {
            state.cdrAiTagRequestData = payload;
        },
        setCDRAvailableTags: (state, {payload}) => {
            state.cdrAiTagResponseData = payload;
        },
    },
});

export const {
    setCDRViewerRequestData,
    setCDRViewerResponseData,
    setHasDialAbility,
    setShowDial,
    setDialNumber,
    setCDRAiTagRequestData,
    setCDRAvailableTags
} = CRMSlice.actions;
